/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react'
import { Modal } from 'react-bootstrap'

import i18n from 'live/services/i18n'

import { OverviewProps } from 'plugin-codaf-risk-ext-bowtie/shared/api'
import { IAlarmEvent, IAlarmSettings } from 'plugin-codaf-risk-ext-bowtie/types/alarms'
import { AlarmEntity } from 'plugin-codaf-risk-ext-bowtie/types/enums'

import { IOperation, IAsset, IBarrier } from '../../../types'
import { BowtieView } from '../../BowtieViews'
import { AlarmList, AssetCard } from './components'
import { AlarmDetails } from './components/AlarmList/components/AlarmDetails/AlarmDetails'
import { AssetSelectorContainer, ModalDetails } from './styles'

export interface IOverviewOperation extends IOperation {
    bowtieViews: BowtieView[]
}
export interface IOverviewAsset extends IAsset {
    operations: IOverviewOperation[]
    assetCode?: number
    status?: string
    overviewAlarms?: IOverviewAlarmEvent[]
    userData: IAlarmSettings
}

export interface IOverviewAlarmEvent extends IAlarmEvent {
    entityName: string
}

export interface IOverviewAlarmAsset extends IAsset {
    overviewAlarms: Map<number, IOverviewAlarmEvent>
}

export interface IBarrierPropsCount {
    /** ALL STATUS EXCEPT UNMONITORED */
    total: number
    /** UNKNOWN - STATUS ID -1 */
    unknown: number
    /** UNMONITORED - STATUS ID -2 */
    unmonitored: number
    [id: number]: number
}
export interface IBarrierCount {
    prevention: Map<number, number>
    mitigation: Map<number, number>
}

export const AssetSelector: React.FC<OverviewProps> = ({
    setSelectedBowtie,
    bowtiesView,
    alarpList,
    setShowAlarmsDashboard,
    alarms,
    setAssetToAlarm,
    assetToAlarm,
    alarmData,
    setAlarmData,
    alarmBowties,
    userData,
    barrierStatusList
}) => {
    const [assetsList, setAssetsList] = useState<IOverviewAsset[]>([])
    const [showAlarmModal, setShowAlarmModal] = useState<boolean>(false)
    const [showAlarmDetailsModal, setShowAlarmDetailsModal] = useState<boolean>(false)
    const [numberOfUnseenAlarms, setNumberOfUnseenAlarms] = useState<number>()
    const [testRender, setTestRender] = useState<number>(0)

    const assetCardRef = useRef<HTMLDivElement[]>([])

    const getNumberOfUnseenAlarms = (): void => {
        const numberOfAlarms = Array.from(alarms).filter(alarm => !alarm[1].seen_by).length
        setNumberOfUnseenAlarms(numberOfAlarms)
    }

    const transformFEBowtieFromAPI = (): IOverviewAsset[] => {
        const assets: IOverviewAsset[] = []
        const overviewAlarmAssets: IOverviewAlarmAsset[] = []

        for (const bowtieView of bowtiesView) {
            const bowtie = bowtieView.bowtie

            let assetIndex = assets.findIndex(ast => ast.id === bowtie.asset.id)

            if (assetIndex === -1) {
                assets.push({ ...bowtie.asset, operations: [], overviewAlarms: [] })
                assetIndex = assets.length - 1
            }

            let operationIndex = assets[assetIndex].operations.findIndex(
                op => op.id === bowtie.topEvent.hazard.operation.id
            )

            if (operationIndex === -1) {
                assets[assetIndex].operations.push({ ...bowtie.topEvent.hazard.operation, bowtieViews: [] })
                operationIndex = assets[assetIndex].operations.length - 1
            }

            let bowtieIsOk = true

            for (const threat of bowtie.topEvent.threats) {
                bowtieIsOk = threat.barriers.length > 0
            }

            for (const consequence of bowtie.topEvent.consequences) {
                bowtieIsOk = consequence.barriers.length > 0

                if (!bowtieIsOk) {
                    break
                }
            }

            if (bowtieIsOk) {
                assets[assetIndex].operations[operationIndex].bowtieViews.push(bowtieView)
            }

            for (const [idx, alarm] of alarms.entries()) {
                let alarmAssetsIndex = overviewAlarmAssets.findIndex(oast => oast.id === bowtie.asset.id)
                if (alarm.entity === AlarmEntity.TOPEVENT) {
                    if (idx === bowtie.topEvent.id) {
                        if (alarmAssetsIndex === -1) {
                            overviewAlarmAssets.push({
                                ...bowtie.asset,
                                overviewAlarms: new Map<number, IOverviewAlarmEvent>()
                            })
                            alarmAssetsIndex = overviewAlarmAssets.length - 1
                        }
                        const alarmWithEntity: IOverviewAlarmEvent = bowtie.topEvent.name
                            ? { ...alarm, entityName: bowtie.topEvent.name }
                            : { ...alarm, entityName: bowtie.topEvent.hazard.name }
                        overviewAlarmAssets[alarmAssetsIndex].overviewAlarms.set(idx, alarmWithEntity)
                    }
                } else if (alarm.entity === AlarmEntity.BARRIER) {
                    const handleRecursiveAlarmTransformation = (barrier: IBarrier): void => {
                        for (const escalation of barrier.escalations) {
                            for (const escalationBarrier of escalation.barriers) {
                                if (alarm.id === escalationBarrier.id) {
                                    if (alarmAssetsIndex === -1) {
                                        overviewAlarmAssets.push({
                                            ...bowtie.asset,
                                            overviewAlarms: new Map<number, IOverviewAlarmEvent>()
                                        })
                                        alarmAssetsIndex = overviewAlarmAssets.length - 1
                                    }
                                    const alarmWithEntity: IOverviewAlarmEvent = {
                                        ...alarm,
                                        entityName: escalationBarrier.name
                                    }

                                    overviewAlarmAssets[alarmAssetsIndex].overviewAlarms.set(idx, alarmWithEntity)
                                }
                                if (escalationBarrier.escalations) {
                                    handleRecursiveAlarmTransformation(escalationBarrier)
                                }
                            }
                        }
                    }

                    for (const consequence of bowtie.topEvent.consequences) {
                        for (const cqBarrier of consequence.barriers) {
                            if (alarm.id === cqBarrier.id) {
                                if (alarmAssetsIndex === -1) {
                                    overviewAlarmAssets.push({
                                        ...bowtie.asset,
                                        overviewAlarms: new Map<number, IOverviewAlarmEvent>()
                                    })
                                    alarmAssetsIndex = overviewAlarmAssets.length - 1
                                }

                                const alarmWithEntity: IOverviewAlarmEvent = {
                                    ...alarm,
                                    entityName: cqBarrier.name
                                }
                                overviewAlarmAssets[alarmAssetsIndex].overviewAlarms.set(idx, alarmWithEntity)
                            }

                            if (cqBarrier.escalations) {
                                handleRecursiveAlarmTransformation(cqBarrier)
                            }
                        }
                    }
                    for (const threat of bowtie.topEvent.threats) {
                        for (const thBarrier of threat.barriers) {
                            if (alarm.id === thBarrier.id) {
                                if (alarmAssetsIndex === -1) {
                                    overviewAlarmAssets.push({
                                        ...bowtie.asset,
                                        overviewAlarms: new Map<number, IOverviewAlarmEvent>()
                                    })
                                    alarmAssetsIndex = overviewAlarmAssets.length - 1
                                }

                                const alarmWithEntity: IOverviewAlarmEvent = {
                                    ...alarm,
                                    entityName: thBarrier.name
                                }
                                overviewAlarmAssets[alarmAssetsIndex].overviewAlarms.set(idx, alarmWithEntity)
                            }

                            if (thBarrier.escalations) {
                                handleRecursiveAlarmTransformation(thBarrier)
                            }
                        }
                    }
                }
            }
        }

        for (const overviewAlarmAsset of overviewAlarmAssets) {
            assets.map(asset => {
                if (asset.id === overviewAlarmAsset.id) {
                    Array.from(overviewAlarmAsset.overviewAlarms.values()).map(alarmEvent =>
                        asset.overviewAlarms.push(alarmEvent)
                    )
                }
            })
        }

        for (const [idx, asset] of assets.entries()) {
            if (asset.operations.length < 1 || !asset.operations.every(op => op.bowtieViews?.length)) {
                delete assets[idx]
            }
        }

        assets.sort((a, b) => a.name.localeCompare(b.name))

        return assets
    }

    useEffect(() => {
        if (bowtiesView) {
            setAssetsList(transformFEBowtieFromAPI())
        }
    }, [bowtiesView]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        getNumberOfUnseenAlarms()
        setAssetsList(transformFEBowtieFromAPI())
    }, [alarms])

    return (
        <>
            <AssetSelectorContainer id="report">
                {(assetsList ?? []).map((asset, index) => (
                    <AssetCard
                        alarpList={alarpList}
                        key={asset.id}
                        setSelectedBowtie={setSelectedBowtie}
                        asset={asset}
                        setShowAlarmModal={setShowAlarmModal}
                        setAssetToAlarm={setAssetToAlarm}
                        userData={userData}
                        barrierStatusList={barrierStatusList}
                    />
                ))}
                {showAlarmModal && (
                    <AlarmList
                        asset={assetToAlarm}
                        setShowAlarmModal={setShowAlarmModal}
                        setShowAlarmsDashboard={setShowAlarmsDashboard}
                        setShowAlarmDetails={setShowAlarmDetailsModal}
                        alarms={alarms}
                        setAlarmData={setAlarmData}
                        setSelectedBowtie={setSelectedBowtie}
                        alarmBowties={alarmBowties}
                    />
                )}

                {showAlarmDetailsModal && (
                    <ModalDetails
                        show={showAlarmDetailsModal}
                        onHide={() => setShowAlarmDetailsModal(false)}
                        aria-labelledby="contained-modal-title"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title id="contained-modal-title">{i18n('Alarm Details')}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={{ padding: 0, height: 600 }}>
                            <AlarmDetails
                                setAlarm={setAlarmData}
                                alarm={alarmData}
                                alarms={alarms}
                                alarmBowties={alarmBowties}
                            />
                        </Modal.Body>
                    </ModalDetails>
                )}
            </AssetSelectorContainer>
        </>
    )
}
